module.exports = __webpack_public_path__ + "static/img/led_l_2.9e77c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/led/led_l_2.png
// module id = 5Pq7
// module chunks = 4